import { BOOKING_CONFIRMATION_OPEN, BOOKING_CONFIRMATION_RESET, BOOKING_CONFIRMATION_SET_STEP, BOOKING_CONFIRMATION_CREATE_STRIPE_INSTANCE, BOOKING_CONFIRMATION_SET_SETUP_INTENT_SECRET, BOOKING_CONFIRMATION_SET_IS_SUBMITTING_CARD, BOOKING_CONFIRMATION_SET_ERROR_TEXT, BOOKING_CONFIRMATION_SET_PAYMENT_REQUIRED_AMOUNT, BOOKING_CONFIRMATION_SET_REFERENCE_CODE, BOOKING_CONFIRMATION_SET_FATAL_MESSAGE } from "../actions/bookingConfirmation";
import { BOOKING_CONFIRMATION_STEPS } from "../../constants";

const defaultState = {
    isPopupOpen: false,
    currentStep: BOOKING_CONFIRMATION_STEPS.NO_CREDIT_CARD,
    isSubmittingCard: false,
    errorText: '',
    paymentRequiredAmount: 0,
    stripeInstance: null,
    setupClientSecret: null,
    bookingReferenceCode: '',
    fatalErrorMessage: '',
}

export const bookingConfirmationReducer = (state = defaultState, action) => {
    switch (action.type) {
        case BOOKING_CONFIRMATION_RESET: {
            return defaultState;
        }
        case BOOKING_CONFIRMATION_OPEN: {
            return { ...state, isPopupOpen: action.isOpen }
        }
        case BOOKING_CONFIRMATION_SET_STEP: {
            return { ...state, currentStep: action.step }
        }
        case BOOKING_CONFIRMATION_CREATE_STRIPE_INSTANCE: {
            return { ...state, stripeInstance: action.instance }
        }
        case BOOKING_CONFIRMATION_SET_SETUP_INTENT_SECRET: {
            return { ...state, setupClientSecret: action.secret }
        }
        case BOOKING_CONFIRMATION_SET_ERROR_TEXT: {
            return { ...state, errorText: action.text }
        }
        case BOOKING_CONFIRMATION_SET_IS_SUBMITTING_CARD: {
            return { ...state, isSubmittingCard: action.isSubmitting }
        }
        case BOOKING_CONFIRMATION_SET_PAYMENT_REQUIRED_AMOUNT: {
            return { ...state, paymentRequiredAmount: action.amount }
        }
        case BOOKING_CONFIRMATION_SET_REFERENCE_CODE: {
            return { ...state, bookingReferenceCode: action.code }
        }
        case BOOKING_CONFIRMATION_SET_FATAL_MESSAGE: {
            return { ...state, fatalErrorMessage: action.message }
        }
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/reducers/bookingConfirmation.js